import React from 'react'
import ReactDOM from "react-dom/client";
import MiniApp from './MiniApp'
import './index.css'
// Drupal behavior to initialize React after lazy builder renders
declare global {
  interface Window {
    Drupal: any;
    drupalSettings: any;
  }
}

(function (Drupal, drupalSettings) {
  Drupal.behaviors.reactLazyBlock = {
    attach: function () {
      const container = document.getElementById("fullcalendar-root");
      if (container) {
        const root = ReactDOM.createRoot(container); // ✅ Correct way in React 18+
        root.render(<MiniApp />);
      }
    },
  };
})(window.Drupal, window.drupalSettings);